import { render, staticRenderFns } from "./FBtn.vue?vue&type=template&id=5bf7b726&"
import script from "./FBtn.vue?vue&type=script&lang=js&"
export * from "./FBtn.vue?vue&type=script&lang=js&"
import style0 from "./FBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports